import React, { useEffect, useState, useRef } from "react";
import ProductIngredientInputForm from "./ProductIngredient-InputForm";
import ProductIngredientResultTable from "./ProductIngredient-ResultTable";
import Loader from "./Loader/Loader.js";
import CONFIG_OBJECT from "../../config/config";
import { postDataFetcher } from "../../dataFetcher";
import App_Constants from "../../app-constants/App_Constants";
import { withTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

import "./product-ingredient.css";

const ProductIngredient = (props) => {
    const { t } = props; //for dictionary phrases
    const [componentData, setComponentData] = useState();
    const [ProductIngredientResultData, setProductIngredientResultData] = useState({
        showResult: false,
        apiData: {},
        loader: false,
        error: "",
    });
    const [itemLanguage] = useState(props.itemLanguage);
    const [showDesc, setShowDesc] = useState(isMobile ? false : true);

    // Default Data to be used for Product-IngredientTable
    let productIngredientInputData = {
        locale: {itemLanguage},
        brand: '',
        productId: 0
    }

    // calling layout service and updating state with product ingredient api response
    useEffect(() => {
        setComponentData(props.fields);
        document.getElementById("btn-calculate").disabled = true;
    }, []);

    // scroll to element function
    const resultRef = useRef(null);
    const executeScroll = () => {
        resultRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }

    const ProductIngredientInputData = (
        brand,
        productId
    ) => {
        productIngredientInputData = {
            brand,
            productId
        };
    }

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const getProductIngredientResult = (e) => {
        e.preventDefault();
        // set the component to loading
        setProductIngredientResultData({
            loader: true,
        });
        console.log("item language - " + itemLanguage);
        let data = {
            Locale: "en-US",
            Brand: productIngredientInputData.brand,
            ProductID: productIngredientInputData.productId
        };

        let restUrl = CONFIG_OBJECT.PRODUCT_INGREDIENT_REST_URL;
        postDataFetcher(`${restUrl}${App_Constants.SC_API_KEY}&sc_lang=en-US`, data)
            .then((response) => {
                Promise.resolve();
                setProductIngredientResultData({
                    showResult: true,
                    apiData: response.data.Data,
                    loader: false, // stop loading
                });
                executeScroll();
            })
            .catch((error) => {
                setProductIngredientResultData({
                    error: error.response.data.Errors,
                    loader: false,
                });
            });
    }

    return (
        <>
            <section
                className="product-ingredient-wrap"
                id="main"
                data-test=""
            >
                <div className="container">
                    {showDesc && (
                        <p className="description">
                            {componentData?.description?.value}
                        </p>
                    )}
                    
                    <div className="form-container">
                        <form onSubmit={handleSubmit} noValidate>
                            <ProductIngredientInputForm
                                componentData={componentData}
                                productIngredientInputData={ProductIngredientInputData}
                            />
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="mt-3">
                                        <button
                                            id="btn-calculate"
                                            className="calculate"
                                            onClick={(e) =>
                                                getProductIngredientResult(e)
                                            }
                                        >
                                            Submit
                                            {/* {t(
                                                "ProductIngredient_SubmitButton"
                                            )} */}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <hr className="form-divider" />
                <div className="container">
                    <div className="result-table" ref={resultRef}>
                        {ProductIngredientResultData.loader && <Loader />}
                        {ProductIngredientResultData.showResult && (
                            <ProductIngredientResultTable
                                componentData={componentData}
                                ProductIngredientResultData={ProductIngredientResultData}
                            />
                        )}
                    </div>
                </div>
                <div className="note-section">
                    <p>
                        Note: Please note that the result table has the ingredients mapped to the ProductID based on the Brand and Locale
                    </p>
                </div>
            </section>
        </>
    );
};

export default withTranslation()(ProductIngredient);
